import dynamic from 'next/dynamic'
import { DemographicsIcon } from 'src/components/insights/icons/demographics'
import { InsightBuilderWidget } from 'src/types/insight-builder'
import preview from 'src/assets/images/widgets-previews/population-by-occupation.png'

const DemographicsPopulationByOccupation = dynamic(
  () => import('src/components/insights/demographics/cards/population-occupation'),
  {
    ssr: false,
  }
)

export const DemographicsPopulationByOccupationWidget: InsightBuilderWidget = {
  id: 'population-by-occupation',
  name: 'Population by Occupation',
  type: 'Demographics',
  icon: DemographicsIcon,
  component: DemographicsPopulationByOccupation,
  supportedResultTypes: ['alphamap-location'],
  preview,
}
